import cookies from 'js-cookie';

export const getFsUid = () =>
  cookies.get('fs_uid') || (window && window.localStorage['_fs_uid']); // eslint-disable-line
